import {
  LOCALE_CODES,
} from '@yescapa-dev/ysc-components/i18n'

export function useZapierChatbot() {
  const SCRIPT_ID = 'zapier-chatbot'

  const route = useRoute()
  const hasScript = ref(false)

  watch(() => route.fullPath, () => {
    hasScript.value = import.meta.client && !!document.getElementById(SCRIPT_ID)
  }, { immediate: true })

  const isPathAllowed = (path: string) => {
    const config = useRuntimeConfig()
    return config.public.zapier.whitelist.includes(path)
  }

  const injectScript = () => {
    const config = useRuntimeConfig()

    if (!document?.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script')
      script.id = SCRIPT_ID
      script.src = config.public.zapier.chatbotSrc
      script.type = 'module'
      script.async = true
      document.head.appendChild(script)
    }
  }

  const removeScript = () => {
    const script = document?.getElementById(SCRIPT_ID)
    if (script) script.remove()
  }

  const chatbotId = computed(() => {
    const { localeProperties: { yscCode } } = useLocaleProperties()
    const config = useRuntimeConfig()
    const chatbotIds = config.public.zapier.chatbotIds

    const localeMapping: Record<string, keyof typeof chatbotIds> = {
      [LOCALE_CODES.FR]: 'fr',
      [LOCALE_CODES.FR_BE]: 'en',
      [LOCALE_CODES.FR_CH]: 'en', // as per notion specification for june the 26th 2025

      [LOCALE_CODES.PT]: 'pt',

      [LOCALE_CODES.IT]: 'it',
      [LOCALE_CODES.IT_CH]: 'en', // as per notion specification for june the 26th 2025

      [LOCALE_CODES.ES]: 'es',
      [LOCALE_CODES.CA]: 'es',

      [LOCALE_CODES.EN]: 'en',
      [LOCALE_CODES.EN_GB]: 'en',
      [LOCALE_CODES.EN_IE]: 'en',

      [LOCALE_CODES.NL]: 'en', // as per notion specification for june the 26th 2025
      [LOCALE_CODES.NL_BE]: 'en',
    }

    const chatbotLocale = localeMapping[yscCode]

    return chatbotIds[chatbotLocale] || null
  })

  return {
    injectScript,
    hasScript,
    isPathAllowed,
    removeScript,
    chatbotId,
  }
}
